// extracted by mini-css-extract-plugin
export var legalBodyLine = "legalPage-module--legal-body-line--URRij";
export var legalBoldLine = "legalPage-module--legal-bold-line--53AF5";
export var legalContent = "legalPage-module--legal-content--H+jSV";
export var legalEmailLink = "legalPage-module--legal-email-link--+1NMH";
export var legalPage = "legalPage-module--legal-page--3vXRg";
export var legalSectionHeading = "legalPage-module--legal-section-heading--y3KpB";
export var legalSeparator = "legalPage-module--legal-separator--f8m8O";
export var legalSpacer = "legalPage-module--legal-spacer--XsvkY";
export var legalTitle = "legalPage-module--legal-title--RKV5s";